import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Grid,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Backdrop,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { IoMdSave } from "react-icons/io";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PhotoUploader from "../../../../components/AddProduct/PhotoUploader";
import productService from "../../../../services/productService";
import { useDispatch, useSelector } from "react-redux";
import { IoMdClose } from "react-icons/io";
import { getbrands } from "../../../../redux/actions/BrandAction";
import NestedCategorySelect from "../../../../components/AddProduct/CategorysSelect";
import categoryService from "../../../../services/categoryService";
import { validateProductUpdate } from "../../../../utils/validation";
import brandSevice from "../../../../services/BrandService";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
const EditProductModal = ({ open, handleClose, productData, onSave }) => {
  const [product, setProduct] = useState({
    title: "",
    stockCode: "",
    supplierBarcode: "",
    quantity: 0,
    categoryId: "",
    brandId: "",
    description: "",
    productImages: [],
    productPrices: [],
    productBarcodes: [],
    brand: {},
    category: {},
  });
  const [description, setDescription] = useState("");
  const [newPhotos, setNewPhotos] = useState([]);
  const [existingPhotos, setExistingPhotos] = useState([]);
  const [marketplaceValues, setMarketplaceValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState("panel");
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [brandsData, setBrandsData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedAttributeId, setSelectedAttributeId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  useEffect(() => {
    if (productData) {
      setProduct({
        title: productData.title || "",
        stockCode: productData.stockCode || "",
        supplierBarcode: productData.supplierBarcode || "",
        quantity: productData.quantity || 0,
        categoryId: productData.categoryId || "",
        brandId: productData.brandId || "",
        description: productData.description || "",
        productImages: productData.productImages || [],
        productPrices: productData.productPrices || [],
        productBarcodes: productData.productBarcodes || [],
        brand: productData.brand || [],
        category: productData.category || [],
        productAttributes: productData.productAttributes || [],
      });
      setDescription(productData.description || "");
      setExistingPhotos(productData.productImages || []);

      const initialMarketplaceValues = {};

      productData.productPrices.forEach((price) => {
        const key =
          price.marketPlace?.name || `ecommerce_${price.ecommercePlaceId}`;
        initialMarketplaceValues[key] = {
          listPrice: price.listPrice,
          salePrice: price.salePrice,
        };
      });

      setMarketplaceValues(initialMarketplaceValues);
    }
  }, [productData]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProduct((prev) => ({ ...prev, [name]: value }));
  };
  const handleInputChangeBrand = (e) => {
    const { name, value } = e.target;

    if (name === "brand") {
      // Seçilen markanın tam verisini bul
      const selectedBrand = brandsData.find((brand) => brand.id === value);

      setProduct((prev) => ({
        ...prev,
        brandId: value, // brandId'yi güncelle
        brand: selectedBrand || {}, // brand objesini güncelle
      }));
    } else {
      setProduct((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleDescriptionChange = (value) => setDescription(value);

  const handleNewPhotosChange = (uploadedPhotos) => {
    const formattedPhotos = uploadedPhotos.map((photo) => ({
      imageBase64: `data:image/png;base64,${photo.base64}`,
    }));
    setNewPhotos(formattedPhotos);
  };

  const handleDeleteExistingPhoto = (id) => {
    setExistingPhotos((prevPhotos) =>
      prevPhotos.map((photo) =>
        photo.id === id ? { ...photo, ia: false } : photo
      )
    );
  };

  const handleSave = async () => {
    const updatedProduct = {
      ...product,
      id: productData.id,
      productMainId: productData.productMainId,
      suplierId: productData.suplierId,
      description,
      productImages: [
        ...existingPhotos.map((photo) => ({
          ...photo,
          ia: photo.ia !== false, // ia=false ise is=false olacak
        })),
        ...newPhotos.map((photo) => ({
          ...photo,
          ia: true, // Yeni eklenen fotoğraflar için is=true
        })),
      ],
      userId: authUserId,
      createDate: productData.createDate,
      // productPrices: Object.keys(marketplaceValues).map((key) => {
      //   const [listPrice, salePrice] = [marketplaceValues[key].listPrice, marketplaceValues[key].salePrice];
      //   const marketPlaceId = product.productPrices.find(
      //     (price) => price.marketPlace?.name === key
      //   )?.marketPlaceId;
      //   return { listPrice, salePrice, marketPlaceId };
      // }),
    };

    try {
      const errors = validateProductUpdate(updatedProduct);
      setFormErrors(errors);
      if (Object.keys(errors).length > 0) return;
      setLoading(true);
      await productService.updateProduct(updatedProduct, token);
      onSave(updatedProduct);
      handleClose();
      setLoading(false);
      // window.location.reload();
    } catch (error) {
      setLoading(false);
      console.error("Error updating product:", error);
    }
  };
  const dispatch = useDispatch();
  useEffect(() => {
    if (authUserId) {
      dispatch(getbrands(authUserId, token));
      fetchCategories();
    }
  }, []);
  const getBrand = async () => {
    var response = await brandSevice.getBrandForDropdown(authUserId);
    setBrandsData(response?.data?.data?.data);
  };
  useEffect(() => {
    getBrand();
    //setBrandsData(brands?.brands?.data)
  }, []);

  const [categories, setCategories] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const fetchCategories = async () => {
    try {
      const response = await categoryService.getCategoriesApiForDropdown(
        token,
        1,
        searchText,
        authUserId
      );

      const fetchedCategories = response.data?.data?.data.map((category) => ({
        id: category.id,
        name: category.name,
        parentId: category.parentId || null,
      }));

      setCategories(fetchedCategories);
    } catch (error) {
      console.error("Kategoriler alınırken bir hata oluştu:", error);
    }
  };
  const handleDeleteAttribute = (attributeId) => {
    setOpenDialog(true);
    setSelectedAttributeId(attributeId);
  };
  const handleCancelDelete = () => {
    setOpenDialog(false);
  };
  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true);
      const result = await productService.deleteProductAttribute(
        selectedAttributeId
      );
      if (result?.data?.status) {
        const updateResponse = await productService.getProductDetails(
          productData.id
        );
        const productUpdateDetails = updateResponse?.data[0];
        if (productUpdateDetails) {
          setProduct({
            title: productUpdateDetails.title || "",
            stockCode: productUpdateDetails.stockCode || "",
            supplierBarcode: productUpdateDetails.supplierBarcode || "",
            quantity: productUpdateDetails.quantity || 0,
            categoryId: productUpdateDetails.categoryId || "",
            brandId: productUpdateDetails.brandId || "",
            description: productUpdateDetails.description || "",
            productImages: productUpdateDetails.productImages || [],
            productPrices: productUpdateDetails.productPrices || [],
            productBarcodes: productUpdateDetails.productBarcodes || [],
            brand: productUpdateDetails.brand || [],
            category: productUpdateDetails.category || [],
            productAttributes: productUpdateDetails.productAttributes || [],
          });
          setDescription(productUpdateDetails.description || "");
          setExistingPhotos(productUpdateDetails.productImages || []);

          const initialMarketplaceValues = {};

          productUpdateDetails.productPrices.forEach((price) => {
            const key =
              price.marketPlace?.name || `ecommerce_${price.ecommercePlaceId}`;
            initialMarketplaceValues[key] = {
              listPrice: price.listPrice,
              salePrice: price.salePrice,
            };
          });

          setMarketplaceValues(initialMarketplaceValues);
          setOpenDialog(false);
          setIsDeleting(false);
          setSelectedAttributeId(null);
          toast.success("Özellik Silindi!", {
            style: {
              background: "#4ADE80",
              borderRadius: "10px",
              color: "#fff",
              boxShadow: "0 4px 12px rgba(74, 222, 128, 0.15)",
            },
            progressStyle: {
              background: "#22C55E",
            },
            icon: "🚀",
          });
        }
      } else {
        setOpenDialog(false);
        setIsDeleting(false);
        toast.error("Bir hata oluştu.", {
          style: {
            background: "#F87171",
            borderRadius: "10px",
            color: "#fff",
            boxShadow: "0 4px 12px rgba(248, 113, 113, 0.15)",
          },
          progressStyle: {
            background: "#EF4444",
          },
          icon: "❌",
        });
      }
    } catch (exx) {
      toast.error("Bir hata oluştu.", {
        style: {
          background: "#F87171",
          borderRadius: "10px",
          color: "#fff",
          boxShadow: "0 4px 12px rgba(248, 113, 113, 0.15)",
        },
        progressStyle: {
          background: "#EF4444",
        },
        icon: "❌",
      });
      setIsDeleting(false);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          margin: { xs: 1, sm: 2 },
          maxHeight: { xs: "calc(100% - 16px)", sm: "calc(100% - 32px)" },
        },
      }}
    >
      <DialogTitle>Ürün Düzenle</DialogTitle>
      <DialogContent sx={{ p: { xs: 1, sm: 2 } }}>
        <Backdrop
          sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <form>
          <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} md={9}>
              <Box
                sx={{
                  padding: { xs: 1.5, sm: 2, md: 3 },
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "500", mb: 1 }}
                >
                  Genel Bilgiler
                </Typography>
                <Grid container spacing={{ xs: 1, sm: 2 }}>
                  {[
                    { label: "Ürün Adı", name: "title", value: product.title },
                    {
                      label: "Model Kodu",
                      name: "stockCode",
                      value: product.stockCode,
                    },
                    {
                      label: "Satıcı Barcode",
                      name: "supplierBarcode",
                      value: product.supplierBarcode,
                    },
                    {
                      label: "Stok",
                      name: "quantity",
                      value: product.quantity,
                    },
                  ].map((field, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <TextField
                        size="small"
                        fullWidth
                        label={field.label}
                        name={field.name}
                        value={field.value || ""}
                        onChange={handleInputChange}
                        error={!!formErrors[field.name]}
                        helperText={formErrors[field.name]}
                      />
                    </Grid>
                  ))}
                </Grid>
                <Typography
                  variant="subtitle1"
                  sx={{ mt: { xs: 2, sm: 3 }, mb: 1 }}
                >
                  Detaylı Açıklama
                </Typography>
                <Box
                  sx={{
                    height: { xs: 150, sm: 200 },
                    border: "1px solid #ddd",
                    borderRadius: 2,
                  }}
                >
                  <ReactQuill
                    value={description}
                    onChange={handleDescriptionChange}
                    theme="snow"
                    style={{ height: "80%" }}
                  />
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: { xs: 1, sm: 2 },
                    mb: { xs: 2, sm: 3 },
                    mt: { xs: 2, sm: 3 },
                  }}
                >
                  <NestedCategorySelect
                    categories={categories}
                    value={product.categoryId}
                    onChange={(selectedValue) => {
                      setProduct((prev) => ({
                        ...prev,
                        categoryId: selectedValue,
                      }));
                    }}
                    error={formErrors.category}
                  />

                  <FormControl
                    size="small"
                    fullWidth
                    error={!!formErrors.brand}
                  >
                    <InputLabel id="brand-select-label">
                      Marka Seçiniz
                    </InputLabel>
                    <Select
                      labelId="brand-select-label"
                      id="brand-select"
                      name="brand"
                      value={product.brand?.id || ""}
                      onChange={handleInputChangeBrand}
                      label="Marka Seçiniz"
                    >
                      <MenuItem value="">
                        <em>Marka Seçiniz</em>
                      </MenuItem>
                      {brandsData?.map((brand) => (
                        <MenuItem key={brand.id} value={brand.id}>
                          {brand.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {formErrors.brand && (
                      <Typography variant="caption" color="error">
                        {formErrors.brand}
                      </Typography>
                    )}
                  </FormControl>
                </Box>

                {existingPhotos.length > 0 && (
                  <Box sx={{ mt: { xs: 2, sm: 3 } }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: "500", mb: 2 }}
                    >
                      Mevcut Fotoğraflar
                    </Typography>
                    <Grid container spacing={{ xs: 1, sm: 2 }}>
                      {existingPhotos
                        .filter((photo) => photo.ia)
                        .map((photo, index) => (
                          <Grid item xs={6} sm={4} md={3} key={index}>
                            <Box
                              sx={{
                                position: "relative",
                                borderRadius: 2,
                                overflow: "hidden",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                textAlign: "center",
                                backgroundColor: "#fff",
                              }}
                            >
                              <img
                                src={
                                  photo.imageUrl ||
                                  `data:image/png;base64,${photo.imageBase64}`
                                }
                                referrerPolicy="no-referrer"
                                alt={`Existing Image ${index + 1}`}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  maxHeight: { xs: 100, sm: 120 },
                                  objectFit: "cover",
                                }}
                              />
                              <Button
                                onClick={() =>
                                  handleDeleteExistingPhoto(photo.id)
                                }
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  minWidth: "unset",
                                  width: 24,
                                  height: 24,
                                  borderRadius: "50%",
                                  backgroundColor: "#f44336",
                                  color: "#fff",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  "&:hover": {
                                    backgroundColor: "#d32f2f",
                                  },
                                }}
                              >
                                &times;
                              </Button>
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
                  </Box>
                )}

                <Box sx={{ mt: { xs: 2, sm: 3 } }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "500", mb: 1 }}
                  >
                    Yeni Fotoğraflar Yükle
                  </Typography>
                  <PhotoUploader onPhotosChange={handleNewPhotosChange} />
                </Box>
              </Box>
              <Grid
                container
                spacing={{ xs: 1, sm: 2 }}
                sx={{ mx: { xs: 0, sm: 1, md: 2 }, mt: { xs: 1, sm: 2 } }}
              >
                {product?.productAttributes?.map((attribute) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={attribute.id}>
                    <Box
                      sx={{
                        p: { xs: 1.5, sm: 2 },
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        height: "100%",
                        position: "relative",
                      }}
                    >
                      <IconButton
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          color: "error.main",
                        }}
                        onClick={() => handleDeleteAttribute(attribute.id)}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>

                      <Typography
                        variant="subtitle2"
                        sx={{ pr: 3, fontWeight: "bold" }}
                      >
                        {attribute.attributeValue?.attribute?.name}
                      </Typography>

                      <Typography variant="body1" sx={{ mt: 0.5 }}>
                        {attribute.attributeValue?.name}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={3}>
              <Accordion
                expanded={expanded === "panel"}
                onChange={() =>
                  setExpanded(expanded === "panel" ? false : "panel")
                }
                sx={{ mb: { xs: 1, sm: 2 } }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                  sx={{
                    backgroundColor: "#1F1B45",
                    color: "white",
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                  }}
                >
                  <Typography>Fiyatlandırma</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: { xs: 1, sm: 2 } }}>
                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      height: { xs: 300, sm: 400, md: 500 },
                      overflowY: "auto",
                    }}
                  >
                    {product.productPrices?.map((prices) => (
                      <div
                        key={prices.id}
                        style={{
                          marginBottom: "1rem",
                          padding: "8px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "500",
                            color:
                              prices?.marketPlace?.colorCode ||
                              prices?.ecommercePlace?.colorCode ||
                              "#000",
                            marginBottom: "8px",
                          }}
                        >
                          {prices?.marketPlace?.name ||
                            prices?.ecommercePlace?.name ||
                            "Bilinmeyen"}
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          label="Liste Fiyatı"
                          variant="outlined"
                          value={prices.listPrice || ""}
                          onChange={(e) => {
                            const updatedprice = product.productPrices?.map(
                              (item) =>
                                item.id === prices.id
                                  ? { ...item, listPrice: e.target.value }
                                  : item
                            );
                            setProduct((prev) => ({
                              ...prev,
                              productPrices: updatedprice,
                            }));
                          }}
                          sx={{ mb: 1 }}
                        />
                        <TextField
                          size="small"
                          fullWidth
                          label="Satış Fiyatı"
                          variant="outlined"
                          value={prices.salePrice || ""}
                          onChange={(e) => {
                            const updatedprice = product.productPrices?.map(
                              (item) =>
                                item.id === prices.id
                                  ? { ...item, salePrice: e.target.value }
                                  : item
                            );
                            setProduct((prev) => ({
                              ...prev,
                              productPrices: updatedprice,
                            }));
                          }}
                          sx={{ mb: 1 }}
                        />
                      </div>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel2"}
                onChange={() =>
                  setExpanded(expanded === "panel2" ? false : "panel2")
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                  sx={{
                    backgroundColor: "#1F1B45",
                    color: "white",
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                  }}
                >
                  <Typography>Barcode</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: { xs: 1, sm: 2 } }}>
                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      height: { xs: 300, sm: 400, md: 500 },
                      overflowY: "auto",
                    }}
                  >
                    {product.productBarcodes.map((barcode) => (
                      <div
                        key={barcode.id}
                        style={{
                          marginBottom: "1rem",
                          padding: "8px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "500",
                            color:
                              barcode?.marketPlace?.colorCode ||
                              barcode?.ecommercePlace?.colorCode ||
                              "#000",
                            marginBottom: "8px",
                          }}
                        >
                          {barcode?.marketPlace?.name ||
                            barcode?.ecommercePlace?.name ||
                            "Bilinmeyen"}
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          label="Barkod"
                          variant="outlined"
                          value={barcode.barcode || ""}
                          onChange={(e) => {
                            const updatedBarcodes = product.productBarcodes.map(
                              (item) =>
                                item.id === barcode.id
                                  ? { ...item, barcode: e.target.value }
                                  : item
                            );
                            setProduct((prev) => ({
                              ...prev,
                              productBarcodes: updatedBarcodes,
                            }));
                          }}
                          sx={{ mb: 1 }}
                        />
                      </div>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </form>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: { xs: 1, sm: 2 },
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 1, sm: 0 },
          }}
        >
          <Button
            variant="outlined"
            startIcon={<IoMdClose />}
            onClick={handleClose}
            fullWidth={false}
            sx={{
              color: "#29275D",
              borderColor: "#29275D",
              textTransform: "none",
              borderRadius: "20px",
              marginRight: { xs: 0, sm: 2 },
              mb: { xs: 1, sm: 0 },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            Kapat
          </Button>

          <Button
            onClick={handleSave}
            variant="contained"
            startIcon={<IoMdSave />}
            fullWidth={false}
            sx={{
              borderRadius: 18,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.875rem",
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
          >
            Kaydet
          </Button>
        </Box>
        <Dialog
          open={openDialog}
          onClose={handleCancelDelete}
          aria-labelledby="alert-dialog-title"
        >
          <DialogTitle id="alert-dialog-title">Özellik Silme</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bu özelliği silmek istediğinize emin misiniz?
              <br />
              <strong>Bu işlem geri alınamaz!</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCancelDelete}
              color="primary"
              disabled={isDeleting}
            >
              Hayır
            </Button>
            <Button
              onClick={handleConfirmDelete}
              color="error"
              variant="contained"
              disabled={isDeleting}
              startIcon={isDeleting ? <CircularProgress size={20} /> : null}
            >
              {isDeleting ? "Siliniyor..." : "Evet, Sil"}
            </Button>
          </DialogActions>
        </Dialog>
      </DialogContent>
    </Dialog>
  );
};

export default EditProductModal;
